export default {
  withus: 'Walk With Us',
  mission: 'Our Mission',
  missiontext:
    'We stand together with the world, bringing clean electricity to all.',
  vision: 'Our Vision',
  visiontext:
    'Green is priceless, to become a global leader in clean power conversion technology.',
  values: 'Core Values',
  sincerity:
    'Sincerity and PragmatismRigor and OpennessInnovation and RespectCustomer Centricity & Mutual Success',
  energytitle:
    'Green energy empowers the world with green momentum and enables everyone to access clean electricity.',
  energytext:
    'This embodies our corporate mission and underlying belief. As the new power system dominated by new energy accelerates its development, green electricity is gradually entering all industries and every household, and the path toward a clean energy future is full of opportunities and challenges.',
  journey: 'Our Development History',
  power: 'Layout of AIDC power supply business launched in 2025.',
  brandvalue: 'Brand value exceeded 10 billion yuan in 2024-2023.',
  inverters:
    'From 2019 to 2023, developed and manufactured grid-connected power......',
  photovoltaic: '2017-2018 Developed medium-voltage direct-connected......',
  cpname: 'Huaneng Shuhang Technology (Beijing) Co., Ltd.',
  cptext: `Huaneng Shuhang Technology (Beijing) Co., Ltd. was founded in 2003. It is a globally leading and innovation-driven industrial technology enterprise.
Relying on profound technical accumulation in the fields of automation, digitalization and intelligence, Huaneng Shuhang has built a business ecosystem featuring coordinated development with homologous technologies covering four major sectors: industrial automation and digitalization, new energy vehicle power systems, intelligent robots, and digital energy. The company is committed to providing global customers with intelligent, efficient, green and safe comprehensive products and solutions.
Headquartered in Shenzhen, it has production bases in Dongguan, Suzhou and other locations.
Focusing on industrial automation, digitalization and intelligent upgrading, Huaneng Shuhang has formed a full-stack layout covering the digital layer, edge layer, control layer, drive layer, execution layer and sensing layer. It continuously delivers cost-effective, user-friendly, easy-to-deploy and upgrade-ready integrated digital and automation solutions for industrial clients.`,
  phone: 'Tel / Telephone: 400 - 852 - 976',
  addr: 'Room 1401-34, 14th Floor, Building 57, Courtyard 2, North Jingyuan Street, Beijing Economic and Technological Development Zone, Beijing City',
  hongkong: {
    name: `Unico Union Limited (HK)`,
    tel: 'Tel:3050 1792',
    email: 'Email:info@yunmatianlong.com',
    adress: `Adress:RM. 2, 3/F., RUBY COMMERCIAL BUILDING, 480 NATHAN ROAD, KLN HONG `,
  },
  shenzeng: {
    name: `Huaneng Digital Navigation Technology (Shenzhen) Co., Ltd.`,
    tel: 'Tel:0755-25701558',
    email: 'Email:info@gedntech.com',
    adress: `Adress:Room 1008C-20, Unit A, Xinian Center,
No.6021 Shennan Boulevard, Tian'an Community, Shatou Subdistrict,
Futian District, Shenzhen City, Guangdong Province, P.R.China `,
  },
  sweden: {
    name: `United Enterprise`,
    tel: 'Tel:+4672330 86 58',
    email: 'info@unitedenterprise.se',
    adress: `Adress: Enterprise Sweden ABHammarby backen 27120 32 Stockholm`,
  },
};
